export default {
  SET_ALL_PERMISSIONS: function (state, payloads) {
    state.allPermissions = payloads;
  },
};
